<div style="min-height: 683px;width:980px;border:1px solid lightgrey;margin-left:auto;margin-right:auto;margin-top:30px;overflow-x:auto;">
  <br>
  <p style="margin-left:20px;"><b>LADDA UPP FOTO [{{member?.id}} - {{member?.givenName}} {{member?.familyName}}]</b></p>
  <div class="col-md-12">
    <span>
      <input type="file" id="file" (change)="fileChangeEvent($event)" />
      <label for="file" style="margin-top:5px;" class="btn border">Välj foto</label>
      <button class="btn border" (click)="cancel()" style="margin-left:20px;">Avbryt</button>
    </span>
  </div>
  <hr />
  <div *ngIf="ready" style="margin-left:10px;padding-bottom:3px;">
    <i class="fa fa-long-arrow-left border" aria-hidden="true" (click)="rotateLeft()"></i>
    &nbsp;&nbsp;
    <b>Rotera foto</b> &nbsp;&nbsp;
    <i class="fa fa-long-arrow-right border" aria-hidden="true" (click)="rotateRight()"></i>
  </div>
  <div *ngIf="ready" class="d-flex justify-content-start gap-2">
    <div style="border:1px solid grey;max-width:800px;">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="3 / 4" [resizeToWidth]="150" [cropperMinWidth]="75" [onlyScaleDown]="true" [roundCropper]="false" [canvasRotation]="canvasRotation"
        [transform]="transform" [alignImage]="'center'" [imageQuality]="92" [style.display]="showCropper ? null : 'none'" format="jpeg" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()"></image-cropper>
      [{{filesize}}]
    </div>
    
   <div style="height:220px; padding-left:5px; padding-right:5px; display:flex; flex-direction:column; align-items:center; justify-content:flex-start;">
  <img [src]="croppedImage"
       [style.border]="croppedImage ? '2px solid #920000' : 'none'"
       style="height:207px;"
       class="ms-2" />

  <button *ngIf="croppedImage"
          class="btn border mt-2"
          (click)="save()">
    <b>Spara</b> &nbsp;({{size}} kB)
  </button>
</div>
    
    
  </div>
</div>